import React, { SVGProps } from 'react';

export default function PaymentCodeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 21 21" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.58497 4.5C1.80916 4.5 1.16137 5.09158 1.09113 5.8642L0.0125647 17.7284C-0.147149 19.4852 1.23615 21 3.00024 21H14.43C16.1941 21 17.5774 19.4852 17.4177 17.7284L17.2738 16.6554H15.7738L15.9239 17.8642C16.0037 18.7426 15.3121 19.5 14.43 19.5H3.00024C2.1182 19.5 1.42655 18.7426 1.5064 17.8642L2.58497 6L14.8453 6L15.2738 9.6554H16.7738L16.3392 5.8642C16.2689 5.09158 15.6211 4.5 14.8453 4.5H11.7151V3C11.7151 1.34315 10.372 0 8.71511 0C7.05826 0 5.71511 1.34315 5.71511 3V4.5H2.58497ZM7.21511 3C7.21511 2.17157 7.88668 1.5 8.71511 1.5C9.54354 1.5 10.2151 2.17157 10.2151 3V4.5H7.21511V3Z"
        fill="currentcolor"
      />
      <rect x="5.52344" y="10.4062" width="14.5" height="5.5" rx="1.75" stroke="currentcolor" strokeWidth="1.5" />
      <path d="M8.97266 11.6562V13.958" stroke="currentcolor" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M10.0742 12.8594L7.77242 12.8594" stroke="currentcolor" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M9.78516 12.0156L8.15754 13.6432" stroke="currentcolor" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M9.78516 13.6484L8.15754 12.0208" stroke="currentcolor" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M12.875 11.6562V13.958" stroke="currentcolor" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M13.9766 12.8594L11.6748 12.8594" stroke="currentcolor" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M17.9805 13.8594L15.6787 13.8594" stroke="currentcolor" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M13.6875 12.0156L12.0599 13.6432" stroke="currentcolor" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M13.6875 13.6484L12.0599 12.0208" stroke="currentcolor" strokeWidth="0.5" strokeLinecap="round" />
    </svg>
  );
}

